import classnames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../constants/common'
import { useContentOverflow } from '../../hooks'
import { getQaSelector } from '../../utils/common'
import { stopPropagation } from '../../utils/events'
import Button from '../Button'
import { FloatingTooltip } from '../Floating'
import { ICON_COLOR, IconNG } from '../Icon'

import {
  CHECKBOX_ICON_SIZE,
  CHECKBOX_SIZE,
  QA_NAME_CHECKBOX_DEFAULT,
} from './Checkbox.constants'
import { isCheckboxTableType } from './Checkbox.utils'
import { CheckboxSkeleton } from './CheckboxSkeleton'

import * as styles from './Checkbox.module.css'

import Selected from '../../icons/checkbox-selected.svg'
import Checked from '../../icons/checkmark.svg'

function Checkbox({
  buttonProps,
  checked = false,
  className,
  disabled = false,
  hasError,
  hovered,
  iconClassName,
  isSkeleton,
  label,
  labelClassName,
  labelTitleClassName,
  name,
  qaName,
  selected = false,
  showTooltip,
  size = CHECKBOX_SIZE.medium,
  tooltip,
  type,
  onChange,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const wrapperClassName = classnames(
    styles.checkbox,
    styles[type],
    {
      [styles.checked]: checked,
      [styles.disabled]: disabled,
      [styles.error]: hasError,
      [styles.hovered]: hovered,
      [styles.selected]: selected,
    },
    className
  )

  const boundingClassName = classnames(
    styles.bounding,
    styles[size],
    iconClassName
  )

  function handleClick(e) {
    stopPropagation(e)
  }

  function handleChange(e) {
    onChange?.(e.target.checked)
  }

  const qaProps = getQaSelector({
    context: QA_NAME_CHECKBOX_DEFAULT,
    def: QA_NAME_CHECKBOX_DEFAULT,
    value: qaName,
  })

  return isSkeleton ? (
    <CheckboxSkeleton />
  ) : (
    <label {...qaProps} className={wrapperClassName} onClick={handleClick}>
      <input
        checked={checked || selected}
        className={styles.input}
        disabled={disabled}
        name={name}
        type='checkbox'
        onChange={handleChange}
      />
      {isCheckboxTableType(type) ? (
        <span className={styles.background} />
      ) : null}
      <FloatingTooltip
        content={tooltip}
        disabled={!tooltip && !showTooltip}
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <span className={boundingClassName}>
          {checked || selected ? (
            <IconNG
              Icon={checked ? Checked : Selected}
              color={ICON_COLOR.White}
              size={CHECKBOX_ICON_SIZE[size]}
            />
          ) : null}
        </span>
      </FloatingTooltip>
      {label ? (
        <FloatingTooltip
          content={tooltip || label}
          disabled={!showTooltip || (!tooltip && !overflow)}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <div
            className={classnames(styles.label, labelClassName)}
            ref={setContentOverflowRef}
          >
            <span className={classnames(styles.title, labelTitleClassName)}>
              {label}
            </span>
            {buttonProps && (checked || selected) ? (
              <Button.Text {...buttonProps} disabled={disabled} />
            ) : null}
          </div>
        </FloatingTooltip>
      ) : null}
    </label>
  )
}

export default Checkbox
